import { FC } from 'react';
// components
import AddSupplier from 'components/main/Supplier/Add';

const AddSuppliers: FC = () => <AddSupplier />;

export default AddSuppliers;
